import React, { useMemo } from 'react';
// @ts-ignore
import styles from './DiscourseAttachments.module.scss';
import DekurzAttachment from '../../../../Components/Dekurz/DekurzAttachment';
import { useDiscourseContext } from '../../Services/DiscourseContext';

interface Props {
	patientId: string;
}

const NOT_ALLOWED_ATTACHMENTS = [
	'content',
	'diagnosis',
	'secondaryDiagnosis',
	'fileId',
	'case',
];

const DiscourseAttachments: React.FC<Props> = ({ patientId }) => {
	const { removeAttachmentFromDiscourse, discourseAttachments } =
		useDiscourseContext();

	const attachments = useMemo(() => {
		return discourseAttachments?.filter(
			(item: any) => !NOT_ALLOWED_ATTACHMENTS.some(type => type === item.type),
		);
	}, [discourseAttachments]);

	return (
		<div className={styles.wrapper}>
			{attachments?.map((item: any) => (
				<DekurzAttachment
					patientId={patientId}
					item={item}
					key={item.id}
					onRemoveAttachment={() => removeAttachmentFromDiscourse(item.id)}
				/>
			))}
		</div>
	);
};

export default DiscourseAttachments;
